import { put, takeEvery } from 'redux-saga/effects';
import {
  startFetchEmailUserTemplate,
  fetchTemplateSuccess,
  fetchTemplateFailure,
} from 'redux/template/actions';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import TemplatesActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { TEMPLATE_BASE_URL } = urls || {};

export function* fetchUserEmailTemplates({ payload }) {
  const url = `${TEMPLATE_BASE_URL}/templates?type=email&index=${
    +payload.currentPage || 0
  }&size=${+payload.pageSize || 10}${
    payload.searchPattern ? `&name=${payload.searchPattern}` : ''
  }`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(
      fetchTemplateSuccess({
        template: response.raw,
        type: 'email',
        explicitType: 'user',
      })
    );
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Templates: ${response.message}`);
    yield put(fetchTemplateFailure(response.message));
  }
}

export function* getEmailUserTemplates() {
  yield takeEvery(
    TemplatesActionTypes.START_FETCH_EMAIL_USER_TEMPLATES,
    fetchUserEmailTemplates
  );
}

export function* fetchSystemEmailTemplates({ payload }) {
  const url = `${TEMPLATE_BASE_URL}/admin?type=email&index=${
    +payload.currentPage || 0
  }&size=${+payload.pageSize || 10}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(
      fetchTemplateSuccess({
        template: response.raw,
        type: 'email',
        explicitType: 'system',
      })
    );
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Templates: ${response.message}`);
    yield put(fetchTemplateFailure(response.message));
  }
}

export function* getEmailSystemTemplates() {
  yield takeEvery(
    TemplatesActionTypes.START_FETCH_EMAIL_SYSTEM_TEMPLATES,
    fetchSystemEmailTemplates
  );
}

export function* updateUserEmailTemplates({ payload }) {
  const { id, active, name, cb } = payload;
  const url = `${TEMPLATE_BASE_URL}/templates/${id}`;

  const response = yield request({
    method: 'patch',
    data: {
      active,
      name
    },
    url,
  });
  if (response.success) {
    yield put(
      startFetchEmailUserTemplate({
        currentPage: 0,
        pageSize: 10,
      })
    );
    Notify('Template updated successfully', {
      position: 'top-right',
      status: 'success',
    });
    if (cb && typeof cb === 'function') {
      cb();
    }
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Update Templates: ${response.message}`);
    yield put(fetchTemplateFailure(response.message));
  }
}

export function* onUpdateEmailUserTemplates() {
  yield takeEvery(
    TemplatesActionTypes.UPDATE_EMAIL_TEMPLATE_START,
    updateUserEmailTemplates
  );
}
